<template>
  <el-dialog
    :title="'【' + modelParam.task_id + '】' + modelParam.describe"
    center
    class="devOps-modelEleven"
    :visible.sync="dialogVisible"
    width="80%"
    top="10px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form
      size="mini"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="40px"
    >
      <el-form-item label="描述" prop="describe">
        <Editor
          :content="form.describe"
          @contentData="changeEditContent"
          placeholder="请输入描述"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          :disabled="runLoading"
          type="warning"
          @click="onSubmit('run')"
          >完成开发<i v-show="runLoading" class="el-icon-loading"></i
        ></el-button>
        <el-button type="warning" @click="handleClose">返回</el-button>
      </el-form-item>
    </el-form>
    <Progress v-if="progressInfo.percentage" :progressInfo="progressInfo" />
    <TableOne v-if="tableData.length" :tableData="tableData" />
    <pre v-if="message" v-html="message" class="tips-message"></pre>
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
} from "@/server/tops/devOps";
import { Progress, Editor } from "@/components/index.js";
import { TableOne } from "../table/index.js";
import { formatDate } from "../util";
export default {
  components: { TableOne, Progress, Editor },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () {};
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {},
      rules: {
        describe: [
          //   { required: true, message: "请输入描述", trigger: "change" },
        ],
      },
      message: "",
      runLoading: false,
      progressInfo: {
        customColor: "#1989fa",
        percentage: 0,
        title: "TOPS",
      },
      skipLoading: false,
      tableData: [],
      quillEditorContent: {},
    };
  },
  async mounted() {
    this.progressInfo.title = this.modelParam.module_name.toUpperCase();
  },
  methods: {
    // 获取任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      const { stage_id, task_id } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          this.form = ret.data;
        } else {
          this.$notify({
            message: ret.error || "获取失败",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      action === "run" && (await this.queryActionRunSubmit("run"));
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.progressInfo = {
            ...this.progressInfo,
            customColor: "#1989fa",
            percentage: 30,
            completeInfo: "",
          };
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;
          const { describe = "" } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            describe,
          };
          this.runLoading = true;
          try {
            const cacheDate = new Date();
            const ret = await postDevopsSpaceStageActionApi(param);
            this.message = JSON.stringify(ret.data || "", null, 2);
            const { msg = [] } = ret?.data?.output || {};
            if (msg[0].code === 0) {
              this.progressInfo = {
                ...this.progressInfo,
                customColor: "",
                percentage: 100,
                status: "success",
                completeInfo:
                  "发布完成，用时：" +
                  formatDate(this, this.$moment(new Date()).diff(cacheDate)),
              };
              setTimeout(()=>{
                this.handleClose()
              },1500)
            } else {
              this.progressInfo = {
                ...this.progressInfo,
                customColor: "",
                percentage: 100,
                status: "exception",
                completeInfo:
                  "发布失败，用时：" +
                  formatDate(this, this.$moment(new Date()).diff(cacheDate)),
              };
            }
          } catch (error) {
            this.progressInfo = {
              ...this.progressInfo,
              customColor: "",
              percentage: 100,
              status: "exception",
              completeInfo: "发布失败",
            };
          } finally {
            this.runLoading = false;
            this.tableData = [];
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeEditContent(val) {
      this.form.describe = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelEleven {
  .el-input__inner {
    font-size: 14px !important;
  }
  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }
  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }
  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }
  .el-button {
    margin-right: 15px;
    letter-spacing: 5px;
    position: relative;
    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>